var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-2",attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"color":_vm.color,"dark":!_vm.disabled,"small":"","text":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":"","color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.title)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }